import { User } from './types';

export const mockAdmins: User[] = [
  {
    id: 'admin-001',
    username: 'jadmin',
    firstName: 'John',
    lastName: 'Admin',
    email: 'jadmin@example.com',
    role: 'SchoolAdmin',
    avatar: 'https://placehold.co/100x100/4a89dc/ffffff?text=JA'
  },
  {
    id: 'admin-002',
    username: 'sadmin',
    firstName: 'Sarah',
    lastName: 'Manager',
    email: 'smanager@example.com',
    role: 'SchoolAdmin',
    avatar: 'https://placehold.co/100x100/da4453/ffffff?text=SM'
  },
  {
    id: 'superadmin-001',
    username: 'superadmin',
    firstName: 'Super',
    lastName: 'Admin',
    email: 'superadmin@example.com',
    role: 'SuperAdmin',
    avatar: 'https://placehold.co/100x100/967adc/ffffff?text=SA'
  }
];
